export enum Role {
  RL_USER = 'RL_USER',
  RL_ADMIN = 'RL_ADMIN',
  RL_SUPER_USER = 'RL_SUPER_USER'
}
